import { getColor } from 'core/utils';
import styled, { css, keyframes } from 'styled-components';

/* Hiding subtotal for now previous height 276... */
const MIN_HEIGHT = 245;

const shimmer = keyframes`
	0% { background-position: -468px 0; }
	100% { background-position: 468px 0; }
`;

const backgroundShimmer = (height) => css`
	animation: ${shimmer} 1s linear infinite forwards;
	background: ${getColor('porcelain')};
	background: linear-gradient(to right, ${getColor('gray1')} 8%, ${getColor('gray2')} 18%, ${getColor('gray1')} 33%);
	background-size: 800px 104px;
	height: ${height || MIN_HEIGHT}px;
	position: relative;
`;

const backgroundMask = css`
	background: ${getColor('white')};
	position: absolute;
`;
// Outer container with that background shimmer
export const Placeholder = styled.div`
	background: ${getColor('white')};
	min-height: ${props => props.withHeight || MIN_HEIGHT}px;
	${backgroundShimmer(MIN_HEIGHT)};
`;

export const ChooseTermMask = styled.div`
	${backgroundMask}
	top: 24px;
	left: 0;
	right: 0;
	height: 12px;
`;

export const ChooseTermMaskRight = styled.div`
	${backgroundMask}
	top: 0;
	right: 0;
	left: 40%;
	height: 24px;
`;

export const TermsYAxis = styled.div`
	${backgroundMask}
	top: 36px;
	left: 47%;
	height: 200px;
	width: 16px;
`;

export const TermsXAxis = styled.div`
	${backgroundMask}
	top: 126px;
	left: 0;
	right: 0;
	height: 16px;
`;

export const TermsMarginBottom = styled.div`
	${backgroundMask}
	top: 232px;
	left: 0;
	right: 0;
	height: 16px;
`;

export const SubtotalMaskRight = styled.div`
	${backgroundMask}
	top: 248px;
	bottom: 0;
	right: 0;
	left: 70%;
`;
